import type { ConfigProviderProps } from 'antd';
import useAntTheme from './antTheme';
import useIssueTheme from './contipleIssueTheme';
import useContipleTheme from './contipleTheme';
import useShadcnTheme from './shadcnTheme';
import { contipleTheme as defaultTheme } from './theme';

export const Theme = {
  CONTIPLE: 'contiple',
  ISSUE: 'issue',
  SHADCN: 'shadcn',
  ANT: 'ant',
};

export type ThemeType = (typeof Theme)[keyof typeof Theme];

export const useTheme = (theme: ThemeType | ConfigProviderProps['theme']) => {
  if (typeof theme === 'object') {
    return { theme: { ...defaultTheme, ...theme } };
  }
  const contipleTheme = useContipleTheme();
  const shadcnTheme = useShadcnTheme();
  const antTheme = useAntTheme();
  const issueTheme = useIssueTheme();

  return theme === Theme.SHADCN
    ? shadcnTheme
    : theme === Theme.ANT
      ? antTheme
      : theme === Theme.ISSUE
        ? issueTheme
        : contipleTheme;
};
